import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

// Crown silhouette for the VIP perps incentive (eyebrow + exclusive-offer card).
// Filled via `currentColor`, so callers tint it with a `text-*` class.
export const CustomCrown = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props}>
        <path d="M3 6.5l4.2 3.3L11.1 4a1.1 1.1 0 0 1 1.8 0l3.9 5.8L21 6.5a1 1 0 0 1 1.57 1.02l-1.7 9.04a1.4 1.4 0 0 1-1.38 1.14H4.51a1.4 1.4 0 0 1-1.38-1.14L1.43 7.52A1 1 0 0 1 3 6.5zM5 19.2c0-.44.36-.8.8-.8h12.4a.8.8 0 0 1 0 1.6H5.8a.8.8 0 0 1-.8-.8z" />
    </SvgIcon>
);
